module.exports = __webpack_public_path__ + "img/germany-leukaemia-female.3029dd78.png";